'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z' });

var FilterList = function FilterList(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

FilterList = (0, _pure2.default)(FilterList);
FilterList.muiName = 'SvgIcon';

exports.default = FilterList;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/FilterList.js
// module id = 2400
// module chunks = 0